export interface TransferCustomerDataServiceType {
  data: any;
}

export const TransferCustomerDataService = () : TransferCustomerDataServiceType => {
  return {
    data: {}
  };
};